import { render, staticRenderFns } from "./newCodigo.vue?vue&type=template&id=16b74807&"
import script from "./newCodigo.vue?vue&type=script&lang=js&"
export * from "./newCodigo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports